import React, { useEffect, useState } from 'react';

import * as S from './styles';
import { theme } from '../../styles/theme';
import { TaglineP } from '../../styles/stylesTypography';

const CellWithText = ({ ...props }) => {
    const handleKeyDown = (e) => {
        if (!props.onClick) return;
        if (e.key === 'Enter' || e.key === ' ') {
            e.preventDefault();
            props.onClick();
        }
    };

    return (
        <S.Container
            bgcolor={props.bgcolor}
            clickable={!!props.onClick}
            onClick={props.onClick}
            role={props.onClick ? 'button' : undefined}
            tabIndex={props.onClick ? 0 : undefined}
            onKeyDown={handleKeyDown}
        >
            {props.icon && <img src={props.icon} alt={props.alt} />}
            <TaglineP color={props.textColor ? props.textColor : theme.colors.white.Branco} fontWeight={800}>
                {props.text}
            </TaglineP>
        </S.Container>
    );
}

export default CellWithText;
